import { useContext } from "react";
import { MethodSystemContext } from "./MethodSystemContext";
import TypeSelection from "./components/TypeSelection";
import OnrampType from "./components/OnrampType";
import OfframpType from "./components/OfframpType";
import CheckoutType from "./components/CheckoutType";
import toast from "react-hot-toast";
import useModal from "../../hooks/useModal";
import useRamp from "../../hooks/useRamp";

export default function useMethodSystem() {
  const context = useContext(MethodSystemContext);
  const { adminCreateRampMethod, adminUpdateRampMethod } = useRamp();
  const { close } = useModal("method-system");
  if (!context) throw new Error("useMethodSystem must be used within a MethodSystemProvider");

  const next = (type) => {
    const views = {
      'onramp': OnrampType,
      'offramp': OfframpType,
      'checkout': CheckoutType
    };
    const Component = views[type];
    if(!Component) return toast.error("Invalid method type selected");
    context.setType(type);
    context.setView(<Component />);
  };

  const createMethod = async (params) => {
    try{
      const data = await (context.id ? adminUpdateRampMethod : adminCreateRampMethod)({
        type: context.type,
        operators: context.operators ? context.operators.map(op => ({
          ...op,
          paymentMethods: [op?.paymentMethods?.card ? 'card' : false, op?.paymentMethods?.bankTransfer ? 'bankTransfer' : false].filter(Boolean)
        })) : undefined,
        ...params,
      }, context.id || undefined);

      toast.success(`Method ${context.id ? 'updated' : 'created'} successfully`);
      context.reloadMethods();
      close();
      return data;
    } catch (error) {
      toast.error(`Error creating method: ${error?.response?.data?.message || error.message}`);
      console.error(error);
    }
  }

  const back = () => {
    context.setView(<TypeSelection />);
    context.setContract(null);
    context.setCurrency(null);
    context.setPaymentMethod(null);
    context.setType(null);
    context.setOperators({});
    context.setNetwork(null);
    context.setRequiresKyc(false);
    context.setAllowedContracts([]);
    context.setTransactions([]);
  }

  return {
    ...context,
    next,
    back,
    createMethod,
  } 
}